<template>
  <div class="s-canvas">
    <canvas
      id="s-canvas"
      :width="contentWidth"
      :height="contentHeight"
      style="margin: 3px 11px"
    ></canvas>
  </div>
</template>
<script>
export default {
  name: 'SIdentify',
  props: {
    identifyCode: {
      type: String,
      default: '1234',
    },
    fontSizeMin: {
      type: Number,
      default: 28,
    },
    fontSizeMax: {
      type: Number,
      default: 32,
    },
    backgroundColorMin: {
      type: Number,
      default: 300,
    },
    backgroundColorMax: {
      type: Number,
      default: 300,
    },
    dotColorMin: {
      type: Number,
      default: 60,
    },
    dotColorMax: {
      type: Number,
      default: 100,
    },
    contentWidth: {
      type: Number,
      default: 95,
    },
    contentHeight: {
      type: Number,
      default: 32,
    }
  },
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    randomColor(min, max) {
      const r = this.randomNum(min, max);
      const g = this.randomNum(min, max);
      const b = this.randomNum(min, max);
      return `rgb(${r},${g},${b})`;
    },
    drawPic() {
      const canvas = document.getElementById('s-canvas');
      const ctx = canvas.getContext('2d');
      ctx.textBaseline = 'bottom';
      ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax);
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
      for (let i = 0; i < this.identifyCode.length; i += 1) {
        this.drawText(ctx, this.identifyCode[i], i);
      }
      this.drawDot(ctx);
    },
    drawText(ctx, txt, i) {
      const ctxIn = ctx;
      ctxIn.fillStyle = this.randomColor(50, 160);
      ctxIn.font = `${this.randomNum(this.fontSizeMin, this.fontSizeMax)}px SimHei`; // 隨機生成字體大小
      const x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
      const y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
      const deg = this.randomNum(0, 0);
      ctxIn.translate(x, y);
      ctxIn.rotate((deg * Math.PI) / 180);
      ctxIn.fillText(txt, 0, 0);
      ctxIn.rotate((-deg * Math.PI) / 180);
      ctxIn.translate(-x, -y);
    },
    drawLine(ctx) {
      for (let i = 0; i < 4; i += 1) {
        const ctxIn = ctx;
        ctxIn.strokeStyle = this.randomColor(100, 200);
        ctxIn.beginPath();
        ctxIn.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctxIn.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctxIn.stroke();
      }
    },
    drawDot(ctx) {
      for (let i = 0; i < 30; i += 1) {
        const ctxIn = ctx;
        ctxIn.fillStyle = this.randomColor(0, 255);
        ctxIn.beginPath();
        ctxIn.arc(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          1,
          0,
          2 * Math.PI
        );
        ctxIn.fill();
      }
    },
  },
  watch: {
    identifyCode() {
      this.drawPic();
    },
  },
  mounted() {
    this.drawPic();
  },
};
</script>
